import { Component, OnInit, Input } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { MultipleSelectItemComponent } from '../multiple-select-item/multiple-select-item.component';
import { DataService } from "../../services/data.service";
import { ActivatedRoute, Router } from '@angular/router';
import { APIService } from '../../api.service';

@Component({
  selector: 'app-transaction',
  templateUrl: './transaction.component.html',
  styleUrls: ['./transaction.component.scss']
})
export class TransactionComponent implements OnInit {

  @Input() isReceive: number = 0;
  @Input() mdlRef: any;

  modalReference: any;
  typeID: any = 0;
  jarvisData: any = [];
  MTbl: any = [];
  WIPNos: any = [];
  isIndian: boolean = false;
  erp_Agn: any = [];
  // isPrdBasic: boolean = false;

  constructor(private modalService: NgbModal, private appService: DataService, private router: Router, private apiService: APIService) { }

  ngOnInit(): void {

    // Get Items
    this.appService.items.subscribe((value :any) => {
    });

    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    var tblM = this.apiService.getCookie("M");
    if(tblM) {
      this.MTbl = JSON.parse(tblM);
      if(this.MTbl.length > 0){
        this.isIndian = this.MTbl[0].CC == 91 ? true : false;
      }
    }

    let tmpERP_Agn = this.apiService.getCookie("ERP_Agn");
    if (tmpERP_Agn) {
      this.erp_Agn = JSON.parse(tmpERP_Agn);
      // if(this.erp_Agn[0].EnblProduction == false){
      //   this.isPrdBasic = true;
      // }
      
    }
    this.getWIPNos();

  }

  getSelectedItem(obj: any) {

  }

  openItemSelect(content: any, id: number, isProduction: boolean) {
    this.modalReference = this.modalService.open(MultipleSelectItemComponent, { windowClass : "itemSelectionModalClass", backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.typeID = id;
    this.modalReference.componentInstance.it = 0;
    this.modalReference.componentInstance.st = 0;
    this.modalReference.componentInstance.isMade = isProduction ? 1 : 0;
    this.modalReference.componentInstance.showSupStore = id == 8 ? true : false;
    this.modalReference.componentInstance.mdlRef = this.modalReference;

    //this.modalReference = this.modalService.open(content,  { windowClass : "itemSelectionModalClass"});
    this.closeModal();
  }

  closeModal() {
    this.mdlRef.close();
  }

  issueProduction(id: number) {
    if(this.WIPNos.length == 0) {
      this.apiService.successAlert('There are no active jobs.');
      return;
    }

    this.closeModal();

    this.router.navigate(['transactionJobs', { id: id }]);
  }


  getWIPNos() {

    let data = [{
      statusID: 1,
      month: 1,
      year: 2021
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      ForERPAgencyID: this.MTbl[0].ERPAgencyID,
      myLastSyncDT: null,
      isWeb: true,
      actionType: 'getPrdJobs',
      moduleID: 8,
      data: JSON.stringify(data)
    }];
    
    this.apiService.getData(myParams, this.successWIPResp.bind(this), this.failureResp.bind(this));
  }

  //successConfigResp - success  get handler
  successWIPResp(res: any) {
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData) {
          let cData = reponseData.Table1;
          this.WIPNos = cData;
          
        }
      }
    }
  }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
    }
    else {
      this.apiService.successAlert(res.message);
      //alert(this.title + ' done!');
    }
  }
 
  
   //redirect basic production
   redirectBasicPrd(id: number) {
    this.router.navigate(['XnProduction']);
    this.closeModal();
  }



}
